<div class="mat-paginator-container">
  <div class="footer-label">
    Елементів на сторінці:
  </div>
  <div class="footer-label footer-label-total">{{total}}</div>
</div>
